import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const IndustryCard = ({ item, index }) => {
  const ref = useRef(null);

  const isInView = useInView(ref, {
    once: true,
    margin: "-80px",
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      style={{
        transform: "translate3d(0,0,0)",
        willChange: "transform, opacity",
      }}
    >
      {/* Static Card */}
      <div
        className="group p-10 rounded-[32px] border border-gray-100 bg-gray-50/50
        text-center transition-all duration-300 hover:border-blue-500/30
        hover:shadow-[0_30px_60px_-15px_rgba(37,99,235,0.1)] hover:bg-white"
      >
        <div
          className="text-5xl mb-6 transition-transform duration-500 group-hover:scale-105 group-hover:rotate-6"
          style={{
            transform: "translate3d(0,0,0)",
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
          }}
        >
          {item.icon}
        </div>

        <h4 className="font-black text-gray-900 text-xl mb-3 tracking-tight">
          {item.title}
        </h4>

        <p className="text-gray-500 text-sm leading-relaxed font-medium">
          {item.desc}
        </p>
      </div>
    </motion.div>
  );
};

const IndustriesSection = () => {
  const industries = [
    {
      icon: "🥫",
      title: "Food & Beverage",
      desc: "FDA-compliant labels with moisture and grease resistance for packaged foods and beverages.",
    },
    {
      icon: "💊",
      title: "Pharmaceutical",
      desc: "GMP-grade labels meeting MRP, batch, and regulatory requirements for drugs and devices.",
    },
    {
      icon: "💄",
      title: "Cosmetics & Beauty",
      desc: "Premium-finish labels that elevate beauty packaging with foil stamping and UV coating.",
    },
    {
      icon: "🛒",
      title: "FMCG & Retail",
      desc: "High-volume, cost-effective labels for consumer brands with shelf-impact colors.",
    },
    {
      icon: "🚚",
      title: "Logistics & Warehousing",
      desc: "Durable shipping labels and thermal labels for supply chain and e-commerce operations.",
    },
    {
      icon: "🏪",
      title: "Retail & Branding",
      desc: "Price tags, hang tags, and branded stickers for organized retail products.",
    },
  ];

  return (
    <section
      id="industries"
      className="py-20 sm:py-24 bg-white overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="text-blue-600 bg-blue-50 border border-blue-600/20 font-black text-xs mb-6 px-5 py-2 w-fit mx-auto rounded-full uppercase tracking-[0.2em]">
            Industries We Serve
          </div>

          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 tracking-tight">
            Trusted Across Sectors
          </h2>

          <p className="text-gray-500 max-w-[650px] mx-auto text-[16px] sm:text-lg leading-relaxed">
            Sahajink provides specialized labeling solutions across Surat and India, 
            understanding the unique compliance and branding needs of every industrial sector.
          </p>
        </div>

        {/* Grid */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((item, i) => (
            <IndustryCard key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
